import { TRoutesTree } from 'types/routes';

import { BaseWrapper } from '@common/providers/BaseWrapper';
import { faHome } from '@fortawesome/free-solid-svg-icons';

import { StorageList } from './contents/storageList';
import { StorageProfile } from './contents/storageProfile';

export const storageRoutesTree: TRoutesTree = [
    {
        path: 'lk',
        wrapper: BaseWrapper,
        icon: faHome,
        custom: {
            isHideMenuOptions: true,
        },
        children: [
            {
                path: '/',
                element: <StorageList />,
                title: 'Склады',
                children: [
                    {
                        path: 'create',
                        breadcrumb: 'Создать склад',
                        element: <StorageProfile />,
                        title: 'Создание склада',
                    },
                    {
                        path: ':storageID',
                        title: ({ storageID }) => `Склад ${storageID}`,
                        element: <StorageProfile />,
                        children: [
                            {
                                path: 'edit',
                                breadcrumb: 'Редактировать',
                                element: <StorageProfile />,
                                title: 'Редактирование склада',
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
